import { api } from "./api";
import { getUtm } from "../utils/utm";

const consentOk = () => localStorage.getItem("viralya-consent") === "accepte";
const getCookie = (n) => {
  const m = document.cookie.match("(^|;)\\s*" + n + "\\s*=\\s*([^;]+)");
  return m ? m.pop() : undefined;
};
const newId = () =>
  (window.crypto && window.crypto.randomUUID) ? window.crypto.randomUUID() : String(Date.now()) + Math.random().toString(16).slice(2);

// Fires the browser Pixel (if loaded) and the server CAPI with a shared event_id for dedup.
export async function track(event_name, opts = {}) {
  if (!consentOk()) return; // no tracking before consent
  const event_id = opts.event_id || newId();
  const custom = { ...(opts.custom || {}), ...getUtm() };
  if (window.fbq) {
    window.fbq("track", event_name, { value: opts.value, currency: "CHF", ...(opts.custom || {}) }, { eventID: event_id });
  }
  try {
    await api.post("/track", {
      event_name, event_id, event_source_url: window.location.href,
      email: opts.email || null, value: opts.value || null, currency: "CHF",
      fbp: getCookie("_fbp"), fbc: getCookie("_fbc"), custom_data: custom,
    });
  } catch (e) { /* best-effort */ }
}
